import { ThemeContext, type ThemeContextValue } from '@/viewmodel/shared/theme/themeContext';
import { use } from 'react';

export function useThemeContext(): ThemeContextValue {
  const ctx = use(ThemeContext);
  if (!ctx) throw new Error('useThemeContext must be used inside ThemeProvider');
  return ctx;
}
